export default __webpack_public_path__ + "static/media/Divinatory Impact.a842a5a4.png";